export type SearchEntryLimitResult = {
	values: string[];
	exceeded: boolean;
	maxEntries: number | null;
};

export function limitSearchEntries(values: string[], maxEntries?: number): SearchEntryLimitResult {
	const normalizedLimit = typeof maxEntries === "number" && Number.isFinite(maxEntries) && maxEntries > 0 ? Math.floor(maxEntries) : null;
	if (normalizedLimit === null || values.length <= normalizedLimit) {
		return { values, exceeded: false, maxEntries: normalizedLimit };
	}

	return {
		values: values.slice(0, normalizedLimit),
		exceeded: true,
		maxEntries: normalizedLimit,
	};
}
